<template>
    <div class="main-content" v-loading="fullScreenLoading">
        <avue-crud ref="crud" :data="tableData" :option="option" :table-loading="showLoading" :page.sync="page"
            @on-load="onLoad" @selection-change="handleSelectedChange">
            <!-- 搜索框-->
            <template #header>
                <div>
                    <div class="flex flex-wrap align-items marginBottom20">
                        <div class="flex align-items marginRight10 marginBottom10"
                            v-for="(item, index) in searchMenuList" :key="index">
                            <span class="span marginRight10 width80 textAlignRight">{{ item.label }} :
                            </span>
                            <div class="width300">
                                <el-input v-if="item.type !== 'select'" v-model="searchData[item.prop]" :placeholder="item.placeholder" clearable
                                    maxlength="50" @keyup.enter.native="handleSearch"></el-input>
                                <el-select v-else v-model="searchData[item.prop]" :placeholder="item.placeholder" clearable>
                                    <el-option v-for="option in item.options" :key="option.value" :label="option.label"
                                        :value="option.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="flex align-items marginRight10 marginBottom10">
                            <span class="span marginRight10 width90 textAlignRight">本地识别类型 :
                            </span>
                            <div class="width300">
                                <el-select v-model="searchData.localRecordType" placeholder="请选择" clearable>
                                    <el-option v-for="item in selectList" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="flex align-items marginRight10 marginBottom10">
                            <span class="span marginRight10 width80 textAlignRight">AI识别类型 :
                            </span>
                            <div class="width300">
                                <el-select v-model="searchData.aiRecordType" placeholder="请选择" clearable>
                                    <el-option v-for="item in selectList" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="flex align-items marginRight10 marginBottom10">
                            <span class="span marginRight10 width80 textAlignRight">触发时间 :
                            </span>
                            <div class="width300">
                                <el-date-picker v-model="searchData.triggerTime" type="daterange" range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期" :clearable="true">
                                </el-date-picker>
                            </div>
                        </div>
                        <div class="flex align-items marginRight10 marginBottom10">
                            <span class="span marginRight10 width90 textAlignRight">波形标签筛选:
                            </span>
                            <div class="width300">
                                <el-cascader v-model="searchData.waveformTagId" placeholder="请选择关联标签" :props="relatedProps">
                                </el-cascader>
                            </div>
                        </div>
                        <el-button size="medium" type="primary" @click="handleSearch" style="margin-bottom: 10px"
                            class="marginLeft10">搜索</el-button>
                        <el-button size="medium" type="info" @click="handleReset" class="marginLeft10"
                            style="margin-bottom: 10px">重置</el-button>
                        <el-button size="medium" type="primary" @click="handleBatchRelated" class="marginLeft10"
                            style="margin-bottom: 10px">批量关联</el-button>
                    </div>
                </div>
            </template>
            <!-- 操作菜单 -->
            <template slot="menu" slot-scope="{ row }">
                <el-button type="text" size="mini" @click="handleDownload(row)">源数据下载</el-button>
                <el-button type="text" size="mini" @click="handleWaveVisible(row)">查看波形</el-button>
                <el-button type="text" size="mini" @click="handleCorrectVisible(row)">类别纠错</el-button>
                <el-button type="text" size="mini" @click="handleRelatedVisible(row)">关联标签</el-button>
            </template>
        </avue-crud>

        <!-- 负载识别波形弹窗-->
        <wave-dialog 
            :visible.sync="waveDialogVisible" 
            :record-id.sync="id"
            :row-data="currentRowData"
            :table-data="tableData"
            :current-index="currentRowIndex"
            @close="handleWaveClose"
            @switch-record="handleSwitchRecord">
        </wave-dialog>

        <!-- 类别纠错弹窗-->
        <el-dialog v-if="correctDialogVisible" title="类别纠错" :visible.sync="correctDialogVisible" width="30%"
            :before-close="handleCorrectClose" :close-on-click-modal="true">
            <div class="fault_box">
                <load-correct :id="id" :current-type="selectType" @close="handleCorrectClose"
                    :select-list="selectList" />
            </div>
        </el-dialog>

        <!-- 关联标签弹窗-->
        <el-dialog v-if="relatedDialogVisible" title="关联标签" :visible.sync="relatedDialogVisible" width="30%"
            :before-close="handleRelatedClose" :close-on-click-modal="true" v-loading="relatedLoading">
            <div class="fault_box">
                <LabelAssociate 
                    :recordIds="recordIds" 
                    operationType="migrate"
                    @close="handleRelatedClose" 
                    @submit="handleRelatedSubmit"/>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import dayjs from "dayjs";
import waveDialog from "./components/waveDialog.vue";
import loadCorrect from "./components/loadCorrect.vue";
import LabelAssociate from "@/components/LabelAssociate/index.vue";
import { loadList, loadDownload } from "@/api/waveform/load";
import { getRelatedOption } from "@/api/waveform/related";

export default {
    name: "index",
    components: {
        waveDialog,
        loadCorrect,
        LabelAssociate
    },
    data() {
        return {
            tableData: [],// 表格数据
            // 表格配置项
            option: {
                title: "",
                titleSize: "h3",
                card: false,
                border: true,
                header: false,
                stripe: false, // 显示斑马纹
                showHeader: true, // 显示表头
                index: false, // 显示索引
                indexLabel: "序号", // 索引文字
                size: "small",
                page: true, // 显示分页
                selection: true, // 显示多选框
                tip: false,
                align: "center",
                menuAlign: "center",
                menuType: "text",
                menuFixed: 'right',
                menuWidth: 280,
                editBtn: false,
                delBtn: false,
                maxHeight: 550,
                column:
                    [
                        {
                            label: "网关地址",
                            prop: "macAddr",
                            width: 140,
                        },
                        {
                            label: "设备类型",
                            prop: "equipmentType",
                            width: 70,
                        },
                        {
                            label: "设备名称",
                            prop: "name",
                            width: 150,
                        },
                        {
                            label: "本地识别类型",
                            prop: "localRecordType",
                            width: 150,
                        },
                        {
                            label: "本地识别概率",
                            prop: "localRecordProbability",
                            width: 100,
                        },
                        {
                            label: "AI识别类型",
                            prop: "aiRecordType",
                            width: 130,
                        },
                        {
                            label: "AI识别概率",
                            prop: "aiRecordProbability",
                            width: 100,
                        },
                        {
                            label: "关联波形库",
                            prop: "waveformTag",
                            width: 120,
                        },
                        {
                            label: "名称版本",
                            prop: "modelNameVersion",
                            width: 120,
                        },
                        {
                            label: "设备型号",
                            prop: "productSpecModel",
                            width: 120,
                        },
                        
                        {
                            label: "所属用户",
                            prop: "nickname",
                            width: 100,
                        },
                        {
                            label: "所属分组",
                            prop: "groupName",
                            width: 150,
                        },
                        {
                            label: "触发时间",
                            prop: "triggerTime",
                            width: 160,
                            fixed: 'right',
                        },
                    ],
            },
            showLoading: false,// 表格加载状态
            // 分页配置项
            page: {
                total: 0,
                currentPage: 1,
            },
            selectList: [],//识别类型列表
            // 搜索数据
            searchData: {
                macAddr: "",
                equipmentType: "",
                triggerTime: "",
            },
            // 搜索框配置项
            searchMenuList: [
                {
                    label: "网关地址",
                    prop: "macAddr",
                    placeholder: "请输入网关地址"
                },
                {
                    label: "设备类型",
                    prop: "equipmentType",
                    placeholder: "请选择设备类型",
                    type: "select",
                    options: [
                        { label: "网关", value: 1 },
                        { label: "断路器", value: 0 }
                    ]
                },
                {
                    label: "设备名称",
                    prop: "name",
                    placeholder: "请输入网关名称",
                },
                {
                    label: "设备型号",
                    prop: "productSpecModel",
                    placeholder: "请输入设备型号",
                },
                {
                    label: "所属用户/ID",
                    prop: "userId",
                    placeholder: "请输入所属用户名称或ID",
                },
                {
                    label: "所属分组/ID",
                    prop: "groupId",
                    placeholder: "请输入所属分组名称或ID"
                }
            ],
            // 关联标签配置项
            relatedProps: {
               lazy: true, // 懒加载
               lazyLoad(node, resolve) {
                if (node.level === 0){
                    getRelatedOption({parentId: node.level}).then(res => {
                        if (res.code === 200) {
                            resolve(res.data); // 加载子节点数据
                        } else {
                            resolve([]); // 加载失败时返回空数组
                        }
                    });
                } else {
                    getRelatedOption({parentId: node.data.value}).then(res => {
                        if (res.code === 200) {
                            resolve(res.data); // 加载子节点数据
                        } else {
                            resolve([]); // 加载失败时返回空数组
                        }
                    }); 
                }
               }
            },
            waveDialogVisible: false, //波形弹窗可视标志
            correctDialogVisible: false, //类别纠错可视标志
            relatedDialogVisible: false, //关联可视标志
            relatedLoading: false, //关联操作加载状态
            recordIds: [], // 需要关联标签的ID
            id: "", //网关id
            selectType: "", //选中条目的识别类别
            fullScreenLoading: false, // 全屏加载状态
            selectedRows: [], // 选中的行数据
            currentRowData: null, // 当前选中的行数据
            currentRowIndex: -1, // 当前选中行的索引
        }
    },

    computed: {
        selectDictionary() {
            return this.$store.getters.getDictionaryList
        }
    },

    mounted() {
        this.fullScreenLoading = true;
        this.onLoad();
    },

    methods: {
        onLoad() {
            this.showLoading = true;
            this.selectList = this.$getDictList(this.selectDictionary, 'cnnModeRecognitionType');
            const searchData = {
                ...this.searchData,
            };
            if (this.searchData.triggerTime) {
                searchData.triggerTimeStart = dayjs(
                    this.searchData.triggerTime[0]
                ).format("YYYY-MM-DD 00:00:00");
                searchData.triggerTimeEnd = dayjs(this.searchData.triggerTime[1]).format(
                    "YYYY-MM-DD 23:59:59"
                );
            }
            if (this.searchData.waveformTagId) {
                searchData.waveformTagId = this.searchData.waveformTagId[1]; // 只传递最后一级的标签ID
            }
            delete searchData.triggerTime;
            
            loadList({
                page: this.page.currentPage,
                size: this.page.pageSize,
                ...searchData,
            }).then((res) => {
                this.showLoading = false;
                this.fullScreenLoading = false; // 隐藏全屏加载动画
                if (res.code === 200) {
                    this.tableData = res.data.records.map((row) => {
                        return {
                            ...row,
                            equipmentType: row.equipmentType == 1 ? "网关" : "断路器",
                            localRecordType: this.$getDictLabel(this.selectDictionary, 'cnnModeRecognitionType', row.localRecordType),
                            aiRecordType: this.$getDictLabel(this.selectDictionary, 'cnnModeRecognitionType', row.aiRecordType)
                        };
                    });
                    this.page.total = res.data.total;
                }
            }).catch(() => {
                this.showLoading = false;
                this.fullScreenLoading = false; // 出错时也隐藏加载动画
            });
        },
        // 表格多选框选中
        handleSelectedChange(selection) {
            this.selectedRows = selection;
        },
        // 查询
        handleSearch() {
            console.log('查询数据', this.searchData)
            this.fullScreenLoading = true; // 显示全屏加载动画
            this.page.currentPage = 1;
            this.onLoad();
        },
        // 重置
        handleReset() {
            // console.log('重置')
            this.searchData = {
                macAddr: "",
                equipmentType: "",
                triggerTime: "",
            };
            this.page.currentPage = 1;
            this.fullScreenLoading = true; // 重置时也显示加载动画
            this.onLoad();
        },

        // 查看负载识别波形
        handleWaveVisible(row) {
            this.id = row.id;
            this.currentRowData = row; // 保存当前行数据
            this.currentRowIndex = this.tableData.findIndex(item => item.id === row.id); // 保存当前行索引
            this.waveDialogVisible = true;
        },

        // 切换记录
        handleSwitchRecord(row, index) {
            this.id = row.id;
            this.currentRowData = row;
            this.currentRowIndex = index;
        },

        // 类别纠错
        handleCorrectVisible(row) {
            this.id = row.id;
            this.selectType = row.aiRecordType;
            this.correctDialogVisible = true;
            console.log('类别纠错', this.waveDialogVisible)
        },

        // 关联标签
        handleRelatedVisible(row) {
            this.recordIds = [row.id];
            this.relatedDialogVisible = true;
        },

        // 关闭波形弹窗
        handleWaveClose() {
            this.waveDialogVisible = false;
            this.id = "";
        },

        // 关闭类别纠错弹窗
        handleCorrectClose() {
            this.correctDialogVisible = false;
        },

        // 关闭关联标签弹窗
        handleRelatedClose() {
            this.relatedDialogVisible = false;
            this.relatedLoading = false;
        },

        // 下载波形数据
        async handleDownload(row) {
            this.showLoading = true;
            await loadDownload(row.id).then(response => {
            try {
                if (!(response.config.responseType === "stream")) {
                    throw new Error('下载失败：响应数据不是文件流');
                }
                // 把 JSON 对象变成字符串
                const text = JSON.stringify(response.data, null, 2);// 格式化：2个空格缩进
                // 创建一个 a 标签用于下载
                const url = window.URL.createObjectURL(new Blob([text], {type: 'text/plain;charset=utf-8'}));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${row.name}识别源数据.txt`); // 设置下载文件名
                document.body.appendChild(link);
                link.click(); // 模拟点击实现下载
                document.body.removeChild(link); // 下载完成后移除元素
                window.URL.revokeObjectURL(url); // 释放 URL 对象

                this.$message({
                        message: '下载成功',
                        type: 'success'
                    });
                } catch (error) {
                    this.$message({
                        message: '下载失败，请重试',
                        type: 'error'
                    });
                }
            })
            this.showLoading = false;
        },

        // 批量关联
        handleBatchRelated() {
            if (this.selectedRows.length === 0) {
                this.$message({
                    message: "请选择要关联的记录",
                    type: "warning",
                });
                return;
            }
            this.recordIds = this.selectedRows.map((row) => row.id); // 获取选中行的ID数组
            this.relatedDialogVisible = true; // 打开关联标签弹窗
        },
        // 提交关联标签
        handleRelatedSubmit() {
            this.relatedLoading = true; // 显示关联操作加载动画
            // 延迟关闭弹窗和刷新数据，让动画有时间显示
            setTimeout(() => {
                this.relatedDialogVisible = false; // 关闭关联标签弹窗
                this.relatedLoading = false; // 隐藏加载动画
                this.onLoad(); // 重新加载数据
            }, 500);
        }
    }
}
</script>

<style scoped>

.fault_box_label {
    margin-right: 10px;
}
</style>